import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MenuButtonComponent } from './menu-button.component';

@NgModule({
  imports: [CommonModule, MatIconModule, MatRippleModule],
  declarations: [MenuButtonComponent],
  exports: [MenuButtonComponent],
})
export class MenuButtonModule {}
